import OpenLocationCode, { type CodeArea } from "./external/open-location-code";

const DEFAULT_PLUS_CODE_LENGTH = 10;

export type DecodedPlusCode = CodeArea;

export function normalizePlusCode(value: string): string {
  return value.trim().toUpperCase();
}

export function isValidPlusCode(value: string): boolean {
  return OpenLocationCode.isValid(value);
}

export function isFullPlusCode(value: string): boolean {
  return OpenLocationCode.isFull(value) && !OpenLocationCode.isShort(value);
}

export function decodePlusCode(value: string): DecodedPlusCode {
  const normalized = normalizePlusCode(value);
  if (!isValidPlusCode(normalized)) {
    throw new Error("Invalid Plus Code");
  }
  if (!isFullPlusCode(normalized)) {
    throw new Error("Plus Code must be a full code");
  }
  return OpenLocationCode.decode(normalized) as DecodedPlusCode;
}

export function encodePlusCode(
  latitude: number,
  longitude: number,
  codeLength = DEFAULT_PLUS_CODE_LENGTH
): string {
  return normalizePlusCode(
    OpenLocationCode.encode(latitude, longitude, codeLength)
  );
}

export function tryDecodePlusCode(value: string): DecodedPlusCode | null {
  try {
    return decodePlusCode(value);
  } catch {
    return null;
  }
}
